package com.parmartechnologies.core.feature.inventory.inventory.network

import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class RetrieveInventoryRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("LastSyncDate") val LastSyncDate: String,
)

@Serializable
data class CreateInventoryRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("inventory_id") var InventoryId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var categoryID: String = "",
    @SerialName("sub_category_id") var subCategoryID: String = "",
    @SerialName("name") var name: String = "",
    @SerialName("description") var description: String = "",
    @SerialName("product_id") var productID: String = "",
    @SerialName("product_price") var productPrice: ProductPrice? = ProductPrice(),
    @SerialName("model") var model: String = "",
    @SerialName("bar_code") var Barcode: String = "",
    @SerialName("brand_id") var brandID: String = "",
    @SerialName("tag_id") var tagID: String = "",
    @SerialName("uom_id") var uomID: String = "",
    @SerialName("color_id") var colorID: String = "",
    @SerialName("quantity") var qty: Long = 0,
    @SerialName("size_id") var sizeID: String = "",
    @SerialName("discount_id") var discountID: String = "",
    @SerialName("coupon_id") var CouponID: String = "",
    @SerialName("ShortCode") var ShortCode: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)

@Serializable
data class UpdateInventoryRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("_id") var _id: String = "",
    @SerialName("inventory_id") var InventoryId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var categoryID: String = "",
    @SerialName("sub_category_id") var subCategoryID: String = "",
    @SerialName("name") var name: String = "",
    @SerialName("description") var description: String = "",
    @SerialName("product_id") var productID: String = "",
    @SerialName("product_price") var productPrice: ProductPrice? = ProductPrice(),
    @SerialName("model") var model: String = "",
    @SerialName("bar_code") var Barcode: String = "",
    @SerialName("brand_id") var brandID: String = "",
    @SerialName("tag_id") var tagID: String = "",
    @SerialName("uom_id") var uomID: String = "",
    @SerialName("color_id") var colorID: String = "",
    @SerialName("quantity") var qty: Long = 0,
    @SerialName("size_id") var sizeID: String = "",
    @SerialName("discount_id") var discountID: String = "",
    @SerialName("coupon_id") var couponID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("created_at") val CreatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("updated_at") val UpdatedAt: LocalDateTime = Clock.System.now().toLocalDateTime(
        TimeZone.UTC),
    @SerialName("__v") var _v: Int = 0
)

@Serializable
data class DeleteInventoryRequest(
    @SerialName("_id") var _id: String = ""
)